// Styles for CardFeature go here.
import styled from 'styled-components';

export const StyledCardFeature = styled.div``;
